import type { FC } from 'react';
import React from 'react';
import classNames from 'clsx';
import { formatClassNames } from '@wix/editor-elements-common-utils';

import styles from './Arrow.module.scss';
import oldStyles from './OLD_Arrow.module.scss';
import semanticClassNames from '../../LoginSocialBar.semanticClassNames';

interface ArrowProps {
  className: string;
  useNewElementStructure: boolean;
  withNewColorWiring: boolean;
}

export const Arrow: FC<ArrowProps> = ({
  className,
  useNewElementStructure,
  withNewColorWiring,
}) => {
  return useNewElementStructure ? (
    <div
      className={classNames(
        formatClassNames(semanticClassNames.arrowIcon),
        semanticClassNames.arrowIcon,
        styles.arrowIcon,
        className,
        {
          [styles.withNewColorWiring]: withNewColorWiring,
        },
      )}
    >
      <div className={styles.arrowWrapper}>
        <div className={styles.arrow}></div>
      </div>
    </div>
  ) : (
    <div
      className={classNames(
        formatClassNames(semanticClassNames.arrowIcon),
        className,
      )}
    >
      <div className={oldStyles.arrowIcon}></div>
    </div>
  );
};
